<template>
  <div>
    <dashboard></dashboard>
  </div>
</template>

<script>

import Dashboard from '@/components/Dashboard.vue'

export default {
  name: 'Home',
  components: {
    dashboard: Dashboard
  },
  created () {
    this.$emit('is-home', true)
  },
  methods: {
  }
}
</script>
